import { getDateAndTimeStrings } from 'helpers/TimeHelpers';
import React from 'react';
import { ScheduledMatch } from 'types/Schedule.types';
import styles from './MatchItem.module.scss';

type MatchItemProps = {
  className?: string;
  onMatchClicked: (matchId: string, match?: ScheduledMatch) => void;
  match: ScheduledMatch;
  selected?: boolean;
};

const MatchItem: React.FC<MatchItemProps> = ({ className = '', match, onMatchClicked, selected = false }) => {
  const baseCls = `${styles.MatchItem} ${className}`;

  const dateAndTimeStrs = getDateAndTimeStrings(match.startingDate);
  const selectedCls = selected ? styles.Selected : '';


  return (
    <div
      key={match.matchId}
      className={`${baseCls} ${selectedCls}`}
      onClick={() => onMatchClicked(match.matchId, match)}
    >
      <span className={styles.MatchItemDate}>{dateAndTimeStrs.dateString}</span>
      <div className={styles.MatchItemTeams}>
        <img className={styles.MatchItemTeam} src={match.home?.team.logoLgUrl} alt="home team" />
        <span className={styles.MatchItemSpacer}>@</span>
        <img className={styles.MatchItemTeam} src={match.away?.team.logoLgUrl} alt="away team" />
      </div>
      <span className={styles.MatchItemTime}>{dateAndTimeStrs.timeString}</span>
    </div>
  );
};

export default MatchItem;
